module.exports = __webpack_public_path__ + "static/media/irakaslea2.9d1a3480.jpg";